const PHOTO_UPLOAD_FILE_TYPES = [
  {
    mime: 'image/jpeg',
    ext: '.jpg',
  },
  {
    mime: 'image/jpeg',
    ext: '.jpeg',
  },
  {
    mime: 'image/png',
    ext: '.png',
  },
  {
    mime: 'image/heif',
    ext: '.heif',
  },
  {
    mime: 'image/heic',
    ext: '.heic',
  },
];

export const PHOTO_UPLOAD_FILE_EXTS = PHOTO_UPLOAD_FILE_TYPES.map(({ ext }) => ext);
export const PHOTO_UPLOAD_FILE_MIMES = PHOTO_UPLOAD_FILE_TYPES.map(({ mime }) => mime);
export const TEN_MB_IN_BYTES = 10485760;

export const PHOTO_UPLOAD_FILE_TYPE_ERROR_KEY =
  'returns.step_2.sidepanel_photo_upload_file_type_error';
export const PHOTO_UPLOAD_FILE_SIZE_ERROR_KEY =
  'returns.step_2.sidepanel_photo_upload_file_size_error';
export const PHOTO_UPLOAD_FILE_LIMIT_ERROR_KEY = (n) =>
  `returns.step_2.sidepanel_photo_upload_file_limit_${n}_error`;
export const PHOTO_UPLOAD_GENERAL_ERROR_KEY = 'returns.step_2.sidepanel_photo_upload_general_error';
